<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-inner-icon="event"
        readonly
        v-on="on"
        @input="handleInput"
        :clearable="clearable"
        :error="error"
        :rules="rules"
        :hide-details="hideDetails"
        :box="box"
        :outline="outline"
        :solo="solo"
        :light="light"
        :disabled="disabled"
      ></v-text-field>
      <!-- <v-text-field
        v-model="date"
        :label="label"
        prepend-inner-icon="event"
        readonly
        v-on="on"
        @input="handleInput"
        :clearable="clearable"
        :error="error"
        :hide-details="hideDetails"
        :box="box"
        :outline="outline"
        :solo="solo"
        :light="light"
      ></v-text-field> -->
    </template>
    <v-date-picker v-model="date" type="month" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="menu = false">Cerrar</v-btn>
      <v-btn flat color="primary" @click="$refs.menu.save(date); $emit('input', date)">Seleccionar</v-btn>
    </v-date-picker>
  </v-menu>

</template>


<script>
  export default {
    props:["value","label","error","rules","hide-details","box","outline","solo","light","clearable","disabled"],
    data: () => ({
      date: null,
      menu: false,
    }),
    watch : {

    },
    created(){

    },
    mounted(){

      if(this.value){
        let date_temp = this.value.toString();
        this.date = date_temp;
      }
    },
    methods: {
      handleInput (e) {
        this.$emit('input', this.date)
        // this.$emit('month_selected', this.date)
      }
    }
  }
</script>
